'use client';

import Image from '@/components/Image';
import MagicJump from '@/components/MagicJump';
import { EPlatform } from '@/utils/enums/platform-enum';

interface SparklyBannerProps {
  pageData: {
    image: string;
    jump_target?: {
      jump_type: string;
      Jump_target: string;
      product_group?: {
        id?: string;
        path?: string;
      };
      sku?: {
        shop_sku: string;
      };
    };
  };
  deviceType: EPlatform;
}

export default function SparklyBanner({ pageData, deviceType }: SparklyBannerProps) {
  if (!pageData?.image) {
    return null;
  }

  // 如果有跳转配置，使用MagicJump包裹
  if (pageData?.jump_target?.Jump_target) {
    return (
      <div className={`banner-wrapper ${deviceType !== EPlatform.WEB ? 'mt-1.5' : ''}`}>
        <MagicJump item={pageData.jump_target} className="banner-container block cursor-pointer">
          <Image
            src={pageData.image}
            alt="sparkly eyeglasses banner"
            width={1200}
            height={400}
            className="banner-img w-full h-auto block"
            priority
          />
        </MagicJump>
      </div>
    );
  }

  // 如果没有跳转配置，直接显示图片
  return (
    <div className={`banner-wrapper ${deviceType !== EPlatform.WEB ? 'mt-1.5' : ''}`}>
      <div className="banner-container">
        <Image
          src={pageData.image}
          alt="sparkly eyeglasses banner"
          width={1200}
          height={400}
          className="banner-img w-full h-auto block"
          priority
        />
      </div>
    </div>
  );
}
